<mat-card data-at-firmware-update-modal-one-time-approval>
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.ONE_TIME_APPROVAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col justify-start">
      <p>
        {{
          '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.ONE_TIME_APPROVAL.DESCRIPTION'
            | translate
        }}
      </p>

      <mat-form-field mat-input-height-small>
        <input
          matInput
          [placeholder]="'123456789'"
          type="text"
          name="firmwareUpdateSearch"
          [formControl]="firmwareUpdateCaseNumberControl"
          gtm="onInput"
          gtmId="salesforce-case-id-search"
          gtmAction="salesforce case id search"
          gtmCategory="FirmwareUpdate"
          [gtmOn]="['change', 'focus', 'blur']"
        />
        <ng-container
          *ngIf="
            (firmwareUpdateStore.errorExtendedPayload$ | async) &&
            (firmwareUpdateStore.salesForceCaseNumber$ | async)
          "
        >
          <mat-error>
            {{
              '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.ONE_TIME_APPROVAL.INVALID_ID'
                | translate
            }}
          </mat-error>
        </ng-container>
      </mat-form-field>
    </div>
  </mat-card-content>

  <mat-card-actions class="!flex flex-row lt-md:flex-col gap-3 justify-end items-center">
    <button
      data-at-firmware-update-modal-finish
      mat-raised-button
      color="primary"
      class="fill-btn lt-md:order-1"
      gtm="onFinishDialog"
      gtmCategory="firmwareUpdate"
      gtmAction="Finish firmware update modal"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
    <button
      data-at-firmware-update-modal-next
      mat-raised-button
      color="primary"
      class="connection-button flex flex-row justify-center items-center lt-md:order-1"
      gtm="onStart"
      gtmCategory="firmwareUpdate"
      gtmAction="Start firmware update installation"
      [disabled]="
        firmwareUpdateCaseNumberControl.invalid || (firmwareUpdateStore.isLoading$ | async)
      "
      (click)="onApply()"
    >
      <ng-container *ngIf="!(firmwareUpdateStore.isLoading$ | async); else spinner">
        <span>{{ 'GENERAL.BUTTON.APPLY' | translate }}</span>
        <mat-icon>arrow_forward</mat-icon>
      </ng-container>
      <ng-template #spinner>
        <span>{{
          '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.ONE_TIME_APPROVAL.CHECKING_SALESFORCE_CASE_NUMBER'
            | translate
        }}</span>
        <mat-spinner></mat-spinner>
      </ng-template>
    </button>
  </mat-card-actions>
</mat-card>
